module.exports = __webpack_public_path__ + "assets/img/b1.6c10a732.jpg";